import React from 'react';
import './confirdialogo.css';

const ConfirmationDialog = ({ isOpen, message, onConfirm, onCancel }) => {
  if (!isOpen) return null;

  return (
    <div className="confirmation-overlay">
      <div className="confirmation-dialog">
        <h3>Confirmación</h3>
        <p>{message}</p>
        <div className="confirmation-buttons">
          <button 
            className="confirm-button" 
            onClick={onConfirm}
          >
            Sí, continuar
          </button>
          <button 
            className="cancel-button" 
            onClick={onCancel}
          >
            No, cancelar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;